import ProfilePage from './ProfilePage.jsx';

export default ProfilePage;